const updates = [
  {
    time: '10:42',
    title: '某短视频顶流账号疑似被平台限流',
    excerpt: '有用户发现该博主近期视频播放量骤降90%，粉丝猜测与近期负面事件有关。51吃瓜黑料将持续关注后续发展。',
    tag: '最新',
  },
  {
    time: '09:15',
    title: '前女团成员深夜发文暗示被公司压榨',
    excerpt: '该艺人发布长文控诉经纪公司存在多项违规操作，声称已被雪藏一年之久。粉丝纷纷涌入评论区力挺偶像维权。',
    tag: '热闻',
  },
  {
    time: '07:30',
    title: '知名综艺节目录制现场发生意外冲突',
    excerpt: '据现场观众透露，两位常驻嘉宾在录制过程中因观点分歧发生激烈争执，导致节目录制中断约两小时。',
    tag: '突发',
  },
  {
    time: '昨天 23:18',
    title: '网曝门新素材流出：娱乐圈大佬饭局现场',
    excerpt: '匿名用户向51吃瓜黑料投稿了一组饭局照片，画面中多位知名人士与神秘女子同桌，引发网友广泛讨论。',
    tag: '爆料',
  },
  {
    time: '昨天 20:05',
    title: '百万粉吃播博主被曝食材造假',
    excerpt: '有网友通过逐帧分析发现该博主的视频存在多处穿帮镜头，所谓的名贵食材实际上是廉价替代品。',
    tag: '打假',
  },
  {
    time: '昨天 17:42',
    title: '某平台年度盛典获奖名单提前泄露',
    excerpt: '一份疑似内部文件在社交平台流传，显示多个重要奖项的最终归属。平台方面暂未对此事作出回应。',
    tag: '独家',
  },
  {
    time: '昨天 14:20',
    title: '网红民宿实为废弃厂房改造引发争议',
    excerpt: '该网红民宿在社交平台出片率极高，但实地探访发现周边环境与宣传严重不符。消费者协会已介入调查。',
    tag: '热闻',
  },
  {
    time: '昨天 11:08',
    title: '电竞圈知名选手被曝私下打假赛',
    excerpt: '匿名爆料人提供多段聊天记录称某冠军选手曾在关键比赛中故意放水。电竞联盟表示将启动调查程序。',
    tag: '深度',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-secondary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            最新动态
          </h2>
          <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
            Timeline
          </span>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-3 bottom-3 w-px bg-background-300/70 hidden md:block"></div>
          <div className="space-y-5">
            {updates.map((item) => (
              <div key={item.time + item.title} className="flex gap-5">
                <div className="hidden md:flex flex-col items-center pt-1 flex-shrink-0">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 ring-4 ring-primary-100 z-10"></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-5 hover:border-primary-300/50 transition-all duration-200 cursor-pointer">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      <i className="ri-time-line mr-1"></i>
                      {item.time}
                    </span>
                    <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap w-fit">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.excerpt}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}